export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5271.8e180256.jpg";